export default __webpack_public_path__ + "a64809f59dda4342c08a1cf9fc35b3ff.svg";